// extracted by mini-css-extract-plugin
export default {"rotateWarning":"RotateWarning_rotateWarning__K8WLE"};